import { canv } from "@/canv/global";
import { drawRoundedRect, isOverRect } from "@/canv/utils";
import { TextWidgetV2 } from "@/elements/text/textV2";
import type { AdvancedCardProgressDataItem } from "./types";

export class CardWidgetStatusBarStatus {
    constructor(startX: number, startY: number, height: number) {
        this.startX = startX;
        this.startY = startY;
        this.height = height;
        this.width = 115; // подобрано, чтобы влезали все статусы

        this.textPart = new TextWidgetV2();
        this.textPart.menuTextSize(18);
        this.textPart.onlyLineMode = true;
        this.textPart.setResizeMode("shape");
        this.textPart.hardWidth = this.width;
        this.textPart.Fit();

        this.updateCoords(this.startX, this.startY);
    }

    updateCoords(startX: number, startY: number) {
        this.startX = startX;
        this.startY = startY;

        this.updateTextPosition();
    }

    updateTextPosition() {
        this.textPart.menuTextAlign("center");
        this.textPart.startX = this.startX + this.width / 2 - this.textPart.width / 2;
        this.textPart.startY =
            this.startY + this.height / 2 - this.textPart.height / 2 + this.textPart.lineHeight;
        this.textPart.updateDims();
    }

    setProgressData(progressData: AdvancedCardProgressDataItem, smooth = true) {
        this.progressData = progressData;
        this.textPart.setText(this.progressData.title);
        this.textPart.menuTextColor(this.progressData.majorColor || "", true);
        this.updateTextPosition();

        if (smooth) this.transitionCounter = this.transitionCounterConst;
    }

    draw() {
        drawRoundedRect(this.startX, this.startY, this.width, this.height, 8);

        if (this.progressData?.minorColor) {
            canv.ctx.strokeStyle = this.progressData.minorColor || "";
        }

        if (
            isOverRect(this.startX, this.startY, this.width, this.height) &&
            this.progressData?.majorColor
        ) {
            canv.ctx.strokeStyle = this.progressData.majorColor;
        }

        canv.ctx.lineWidth = 2;
        canv.ctx.stroke(); // нужно, иначе checkbox будет больше по размеру

        const memGlobalAlpha = canv.ctx.globalAlpha;

        if (this.transitionCounter !== 0) {
            const perc = 1 - this.transitionCounter / this.transitionCounterConst;
            canv.ctx.globalAlpha = perc;

            this.transitionCounter--;
            canv.redraw();
        }

        if (this.progressData?.minorColor) {
            canv.ctx.fillStyle = this.progressData.minorColor;
        }

        canv.ctx.fill();

        this.textPart.draw();

        canv.ctx.globalAlpha = memGlobalAlpha;

        this.drawPoints();
    }

    drawPoints() {
        const padding = 5;
        const pointD = (this.height - 4 * padding) / 3;

        canv.ctx.lineWidth = 1;

        this.drawPoint(this.startX + this.width + padding, this.startY + padding, pointD, "todo");
        this.drawPoint(
            this.startX + this.width + padding,
            this.startY + pointD + 2 * padding,
            pointD,
            "progress",
        );
        this.drawPoint(
            this.startX + this.width + padding,
            this.startY + 2 * pointD + 3 * padding,
            pointD,
            "done",
        );
    }

    drawPoint(startX: number, startY: number, d: number, targetStatus: string) {
        canv.ctx.strokeStyle = "#ECECEC";

        if (this.progressData && this.progressData.name === targetStatus) {
            canv.ctx.strokeStyle = this.progressData.majorColor || "";
            canv.ctx.fillStyle = this.progressData.majorColor || "";
        }

        drawRoundedRect(startX, startY, d, d, d * 10);
        canv.ctx.stroke();

        if (this.progressData?.name === targetStatus) {
            canv.ctx.fill();
        }
    }

    startX = 0;
    startY = 0;
    width = 0;
    height = 0;

    textPart: TextWidgetV2;
    progressData: AdvancedCardProgressDataItem | null = null;

    transitionCounter = 0;
    transitionCounterConst = 20;
}
